var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiungn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.62762 23.2148L3 22.6786L11.0025 12.34L15.3045 19.0766L23.2808 4.21484L24 4.64112L15.3568 20.6988L10.9372 13.7837L3.62762 23.2148Z",
    fill: "#383838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49991 27.2148C1.12566 27.2148 0 26.089 0 24.7148C0 23.3405 1.12566 22.2148 2.49991 22.2148C3.87416 22.2148 5 23.3405 5 24.7148C5 26.089 3.87416 27.2148 2.49991 27.2148ZM2.49991 23.1213C1.62273 23.1213 0.906414 23.8376 0.906414 24.7148C0.906414 25.5919 1.62273 26.3084 2.49991 26.3084C3.37709 26.3084 4.09359 25.5919 4.09359 24.7148C4.09359 23.8376 3.37709 23.1213 2.49991 23.1213Z",
    fill: "#383838"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5001 5C23.1258 5 22 3.8743 22 2.5C22 1.1257 23.1258 0 24.5001 0C25.8743 0 27 1.1257 27 2.5C27 3.8743 25.8743 5 24.5001 5ZM24.5001 0.906446C23.6229 0.906446 22.9064 1.62279 22.9064 2.5C22.9064 3.37721 23.6229 4.09355 24.5001 4.09355C25.3773 4.09355 26.0936 3.37721 26.0936 2.5C26.0936 1.62279 25.3773 0.906446 24.5001 0.906446Z",
    fill: "#383838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiungn);
export default __webpack_public_path__ + "static/media/biểu đồ đường đơn.b03e811f438cb2f3d8f3548084dc0dc3.svg";
export { ForwardRef as ReactComponent };